// Decisions for the shop section on the race page (components/race/detail.js).
//
// The webshop page (/products) only shows the DOMAIN customer's products, so a
// "See all products" link is only valid when the race customer is that domain
// customer. The guest basket is for visitors who are not logged in, on shops
// that take Vipps (guestCartStore.canCheckout).

const asId = value => parseInt(value, 10) || 0;

const showSeeAllProductsLink = ({ currentCustomerId, raceCustomerId }) => {
    const current = asId(currentCustomerId);
    return current > 0 && current === asId(raceCustomerId);
};

const showGuestBasketButton = ({ userId, canCheckout }) => !asId(userId) && !!canCheckout;

const shouldLoadGuestCart = ({ userId, raceCustomerId }) => !asId(userId) && asId(raceCustomerId) > 0;

export { showSeeAllProductsLink, showGuestBasketButton, shouldLoadGuestCart };
